import {EarlyAccessAction} from 'app/reducers/earlyAccessReducer';

function updateEarlyAccessFeature(data: Record<string, string>): EarlyAccessAction {
  return {
    data,
    type: 'EARLY_ACCESS_FEATURE_UPDATE',
  };
}

export {updateEarlyAccessFeature};
